var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { difference, intersection, keys } from 'lodash';
import useForm from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { object, string } from 'yup';
import { Button, Divider, Grid, TextField } from '@material-ui/core';
import { enterKeyPress, getPostData, useEmailSignUpFormStyles, } from './EmailSignUpFormTypes';
import { SignUpTerms } from './SignUpTerms';
import { useTextFieldErrorStyles, useTextFieldStyles, useTextFieldStylesLOH } from './TextFieldStyles';
import { useAuthFormState } from './useAuthFormState';
import { openAuth0DOMPopup } from './redirect-popup';
import { Loading } from '../Loading/Loading';
import { useEnvironment, useEventListener } from '../../shared/hooks';
export function Auth0SignUpForm(props) {
    var _this = this;
    var _a = props.isModal, isModal = _a === void 0 ? true : _a, redirectTo = props.redirectTo, team = props.team, _b = props.hideLogin, hideLogin = _b === void 0 ? false : _b, signUpCta = props.signUpCta, _c = props.switchToLoginForm, switchToLoginForm = _c === void 0 ? function () { } : _c, _d = props.isLoggedOutHome, isLoggedOutHome = _d === void 0 ? false : _d;
    var classes = useEmailSignUpFormStyles(props);
    var useTextFieldStylesClassesLOH = useTextFieldStylesLOH();
    var useTextFieldStylesClasses = useTextFieldStyles();
    var textFieldClasses = isLoggedOutHome ? useTextFieldStylesClassesLOH : useTextFieldStylesClasses;
    var textFieldErrorClasses = useTextFieldErrorStyles();
    var emailSignUpState = useAuthFormState();
    var appHost = useEnvironment().appHost;
    var _e = __read(useState(''), 2), generalError = _e[0], setGeneralError = _e[1];
    var _f = __read(useState(false), 2), isSubmitting = _f[0], setIsSubmitting = _f[1];
    var intl = useIntl();
    var firstNameMax = intl.formatMessage({
        id: 'authentication.sign-up-form.firstname.max',
        defaultMessage: 'Name fields must be fewer than 50 characters',
        description: 'For a max of characteres allowed.',
    });
    var firstNameRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.firstname.required',
        defaultMessage: 'First Name is required',
        description: 'Referring to an input that is required for the user.',
    });
    var lastNameMax = intl.formatMessage({
        id: 'authentication.sign-up-form.lastname.max',
        defaultMessage: 'Name fields must be fewer than 50 characters',
        description: 'For a max of characteres allowed.',
    });
    var lastNameRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.lastname.required',
        defaultMessage: 'Last Name is required',
        description: 'Referring to an input that is required for the user.',
    });
    var emailMin = intl.formatMessage({
        id: 'authentication.sign-up-form.email.min',
        defaultMessage: 'Email field must have at least 5 characters',
        description: 'Minimal value for user input.',
    });
    var emailMax = intl.formatMessage({
        id: 'authentication.sign-up-form.email.max',
        defaultMessage: 'Email field must be fewer than 100 characters',
        description: 'For a max of characteres allowed.',
    });
    var emailNotValid = intl.formatMessage({
        id: 'authentication.sign-up-form.email.invalid',
        defaultMessage: 'Email field is not a valid email address.',
        description: 'Referring to an invalid user input.',
    });
    var emailRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.email.required',
        defaultMessage: 'Email is required',
        description: 'Referring to an input that is required for the user.',
    });
    var EmailSignUpFormSchema = object().shape({
        firstName: string().trim().max(50, firstNameMax).required(firstNameRequired),
        lastName: string().trim().max(50, lastNameMax).required(lastNameRequired),
        email: string().trim().min(5, emailMin).max(100, emailMax).email(emailNotValid).required(emailRequired),
    });
    var _g = useForm({
        mode: 'onSubmit',
        validationSchema: EmailSignUpFormSchema,
    }), register = _g.register, handleSubmit = _g.handleSubmit, errors = _g.errors, setError = _g.setError, clearError = _g.clearError, getValues = _g.getValues, triggerValidation = _g.triggerValidation;
    var enterKeyHandler = function (event) {
        enterKeyPress({ event: event, validate: triggerValidation, onSubmit: onSubmit }, true);
    };
    useEventListener({ eventName: 'keydown', handler: enterKeyHandler });
    var onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            submitForm();
            return [2];
        });
    }); };
    var submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, urlParams, urlRedirectTo, postData, urlPortions, landingPageUrl, email, firstName, lastName, origin_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            data = getValues();
            urlParams = new URLSearchParams((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '');
            urlRedirectTo = (_c = redirectTo !== null && redirectTo !== void 0 ? redirectTo : urlParams.get('redirectTo')) !== null && _c !== void 0 ? _c : '';
            postData = getPostData({
                data: data,
                recaptchaResponse: emailSignUpState.recaptcha.recaptchaResponse,
                redirectTo: urlRedirectTo,
                csrfToken: emailSignUpState.csrfToken,
                team: team,
            });
            urlPortions = window.location.href.split('?url=');
            if (window.top !== window.self && urlPortions.length > 1) {
                landingPageUrl = decodeURIComponent(window.location.href.split('?url=')[1]);
                postData.append('landing_page_url', landingPageUrl);
            }
            setIsSubmitting(true);
            clearError();
            setGeneralError('');
            try {
                email = data.email;
                firstName = data.firstName;
                lastName = data.lastName;
                origin_1 = (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.location) === null || _d === void 0 ? void 0 : _d.origin) !== null && _e !== void 0 ? _e : appHost) !== null && _f !== void 0 ? _f : '';
                openAuth0DOMPopup(origin_1, email, firstName, lastName);
            }
            catch (error) {
                handleErrorResponse(error);
                setIsSubmitting(false);
            }
            return [2];
        });
    }); };
    var generalErrorMsg = intl.formatMessage({
        id: 'authentication.sign-up-form.submit.general.error',
        defaultMessage: 'Something went wrong. Please try again later',
        description: 'Message that shows up for general purpose.',
    });
    var handleErrorResponse = function (error) {
        if (error.response.status >= 500) {
            setGeneralError(generalErrorMsg);
            return;
        }
        var errors = error.response.data.errors;
        if (typeof errors === 'string') {
            setGeneralError(errors);
            return;
        }
        var inputErrorFields = intersection(EmailSignUpFormSchema._nodes, keys(errors));
        inputErrorFields.forEach(function (field) {
            setError(field, '', errors[field][0]);
        });
        var generalErrorFields = difference(keys(errors), inputErrorFields);
        generalErrorFields.forEach(function (field) {
            setGeneralError(errors[field][0]);
        });
    };
    var onClickLogin = function (event) {
        event.preventDefault();
        if (isModal) {
            switchToLoginForm(true);
            return;
        }
        window.location.pathname = '/login';
    };
    var errorClass = clsx('error', textFieldErrorClasses.root);
    var emailMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.email.message',
        defaultMessage: 'Email address',
        description: 'Text for label and placeholder of input email address on sign up form.',
    });
    var firstNameMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.firstname.message',
        defaultMessage: 'First name',
        description: 'Text for label and placeholder of input first name on sign up form.',
    });
    var lastNameMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.lastname.message',
        defaultMessage: 'Last name',
        description: 'Text for label and placeholder of input lastname on sign up form.',
    });
    var signUpMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.button.text',
        defaultMessage: 'Sign Up',
        description: 'Text for a button with the action of sign up.',
    });
    return (React.createElement("form", { autoComplete: "off" },
        React.createElement(Grid, { container: true, className: classes.grid },
            (errors.firstName && React.createElement("p", { className: errorClass }, errors.firstName.message)) ||
                (errors.lastName && React.createElement("p", { className: errorClass }, errors.lastName.message)) ||
                (generalError && React.createElement("p", { className: errorClass }, generalError)),
            React.createElement(Grid, { container: true, item: true, xs: 12, justify: "space-between", direction: "row", className: classes.FirstLastName_loh },
                React.createElement(TextField, { name: 'firstName', inputRef: register, inputProps: {
                        'aria-label': firstNameMessage,
                    }, placeholder: firstNameMessage, variant: "outlined", classes: textFieldClasses, className: classes.nameField }),
                React.createElement(TextField, { name: 'lastName', inputRef: register, inputProps: {
                        'aria-label': lastNameMessage,
                    }, placeholder: lastNameMessage, variant: "outlined", classes: textFieldClasses, className: classes.nameField })),
            errors.email && React.createElement("p", { className: errorClass }, errors.email.message),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TextField, { name: 'email', type: 'email', inputRef: register, inputProps: {
                        'aria-label': emailMessage,
                        className: team && team.invitation ? 'bold' : 'normal',
                        readOnly: team && !!team.invitation,
                    }, placeholder: emailMessage, variant: "outlined", classes: textFieldClasses, className: 'bold' })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Button, { onClick: handleSubmit(submitForm), variant: "contained", color: "primary", disableElevation: true, className: clsx('submit-btn', classes.submitBtn), disabled: isSubmitting, "data-cy": "signup-embedded-btn" }, isSubmitting ? (React.createElement(Loading, { size: 39, fillColor: '#FFF' })) : team && (team.isSignUp || team.isInvitation) ? (team.submitText) : (signUpCta !== null && signUpCta !== void 0 ? signUpCta : signUpMessage))),
            !team && (React.createElement(React.Fragment, null,
                !hideLogin && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement("div", { className: isLoggedOutHome ? classes.member_loh : classes.member },
                            React.createElement(FormattedMessage, { id: "authentication.sign-up-form.registered-member.text", defaultMessage: "Already a member?", description: "Text for asking to the user if is already a member." }),
                            React.createElement("button", { className: "link", onClick: onClickLogin },
                                React.createElement(FormattedMessage, { id: "authentication.sign-up-form.signin.text", defaultMessage: "Sign In", description: "Text for the user to sign in." })))),
                    React.createElement(Grid, { item: true, xs: 12, className: isLoggedOutHome ? classes.separator_loh : classes.separator },
                        React.createElement(Divider, null)))),
                React.createElement(Grid, { className: classes.terms, item: true, xs: 12 },
                    React.createElement(SignUpTerms, { isLoggedOutHome: isLoggedOutHome })))))));
}
//# sourceMappingURL=Auth0SignUpForm.js.map